import { dataSourceOptions } from '../config/constants/apiConstants';

export const findDataSourceName = (dataSource) => {
  const option = dataSourceOptions.find(opt => opt.id === dataSource);
  return option ? option.name : 'Unknown';
};
